import React, { FunctionComponent } from 'react';
import { Progress } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  totalBudget: number;
  balance: number;
};

const styles = {
  doshProgress: {
    marginBottom: '.3125rem !important',
  },
  loader: {
    marginBottom: '1.5rem !important',
  },
};

const ProgressBar: FunctionComponent<Props> = ({
  classes,
  totalBudget,
  balance,
}) => {
  const percentageRemaining = balance > 0 ? (balance / totalBudget) * 100 : 0;

  return (
    <Progress
      percent={percentageRemaining}
      indicating
      className={classes.doshProgress}
    />
  );
};

export default withStyles(styles)(ProgressBar);
